module.exports = __webpack_public_path__ + "static/img/16areaB_6.aa267d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/16areaB_6.png
// module id = 1144
// module chunks = 1